import React, { createContext, useContext, ReactNode } from 'react';

import useCioSearchAndGqlProducts from '~/gridv1_1/hooks/useCioSearchAndGqlProducts';

import { CIOSearchProductGridResponse } from '../types/gridResponses';

type CIOSearchContextType = CIOSearchProductGridResponse | undefined;

const CIOSearchContext = createContext<CIOSearchContextType>(undefined);

interface CIOSearchProviderProps {
  children: ReactNode;
}

export const CIOSearchProvider = ({ children }: CIOSearchProviderProps) => {
  const cioData = useCioSearchAndGqlProducts();

  return (
    <CIOSearchContext.Provider value={cioData}>
      {children}
    </CIOSearchContext.Provider>
  );
};

export const useCioSearchContext = (): CIOSearchContextType => {
  return useContext(CIOSearchContext);
};
